// extracted by mini-css-extract-plugin
module.exports = {"accordionItem":"styles_accordionItem__3mhLK","browser-ie":"styles_browser-ie__1XdSJ","closed":"styles_closed__2etUh","animating":"styles_animating__1JHJx"};